import React from "react"
import PropTypes from "prop-types"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"
import CardFooter from "components/CardFooter"

// Assets
import dlPageStyle from "./dlPageStyle.jsx"

// @material-ui/core components
// core components
import Footer from "components/Footer";
import logoMini from "../assets/logo/Logo_Octiva_WHITE_RGB_no_text.png";
import playButton from "../assets/img/downloadbuttons/GetItOnGooglePlay_Badge_Web_color_English.png"
import appStoreButton from "../assets/img/downloadbuttons/Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917.svg"
import { isIOS, isAndroid, isBrowser } from "react-device-detect"
import { Grid, Paper } from "@mui/material"
import QRCode from "react-qr-code"

class DownloadPage extends React.Component {
  constructor(props) {
    super(props)
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      isApple: false,
      
    }
  }

  openIOSLink() {
    const url = window.REACT_APP_IOS_URL
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  openAndroidLink() {
    const url = window.REACT_APP_ANDROID_URL
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  render() {
    const {classes} = this.props

    var brandFooter = (
      <div>
        <a href={'https://' + window.location.hostname} className={classes.logoFooter}>
          <img src={logoMini} alt="logo" className={classes.imgFooter}/>
        </a>
      </div>
    );

    return (
      <div style={{overflow: "hidden"}}>
        <div className={classes.wrapper} ref="wrapper">
          <div
            className={classes.fullPage}
            style={{backgroundColor: "#638813"}}
          >
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10} xl={8}>
                  <Card login>
                    <CardHeader
                      className={`${classes.cardHeader} ${classes.textCenter}`}
                      color="primary"
                    >
                      <h4>{"Download the Octiva app here:"}</h4>
                    </CardHeader>
                    <CardBody>
                      <Grid 
                        container  
                        spacing={2}
                        className={classes.containerGrid}>
                          { !isIOS && <Grid item xs={12} s={12} lg={6}><Paper onClick={this.openAndroidLink} className={[classes.appCard, classes.transition]} elevation={8}> <h4>Download for your Android device</h4>
                            <img src={playButton} alt="logo" className={classes.imgDownload}/></Paper></Grid>}
                          { !isAndroid && <Grid item xs={12} s={12} lg={6}><Paper onClick={this.openIOSLink} className={[classes.appCard, classes.transition]} elevation={8}> <h4>Download for your IOS device</h4>
                            <img src={appStoreButton} alt="logo" className={classes.imgDownload}/></Paper></Grid>}
                          { isBrowser && <Grid item xs={12} s={12} lg={12}><Paper className={[classes.appCard, classes.transition]} elevation={8}> <h4>Device detection failed, scan the QR code with your mobile device</h4>
                            <QRCode value={window.location.href}/></Paper></Grid>}
                      </Grid>
                    </CardBody>
                    <CardFooter className={classes.justifyContentCenter}>
                    </CardFooter>
                  </Card>
                </GridItem>
              </GridContainer>
            </div>
            <Footer white/>
          </div>
          {brandFooter}
        </div>
      </div>
    )
  }
}

DownloadPage.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(dlPageStyle)(DownloadPage)
